'use client';

import { useTranslations } from 'next-intl';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { leaseTermsText, sectionHeading } from './costAndFeesModule.styles';

type Props = {
  listing: PropertyDetailListing;
};

export const LeaseTermsInline = ({ listing }: Props) => {
  const t = useTranslations('hdp');
  const leaseTerms = listing.details?.leaseTerms;
  if (!leaseTerms) return null;

  return (
    <div>
      <h3 className={sectionHeading}>{t('leaseTerms')}</h3>
      <p className={leaseTermsText}>{leaseTerms}</p>
    </div>
  );
};
